export default "__VITE_ASSET__CnH3w1LH__"